import React, { useState } from 'react';
import { node } from 'prop-types';
//Constants
import { API_URL } from '@constants';
//Hooks
import { useRequest } from '@hooks/useFetch';
//Helpers
import queryParamBuilder from '@helpers/queryParamBuilder';

export const GlobalVariableContext = React.createContext({
  groups: [],
  regions: { provinces: [], cities: [], districts: [], villages: [], subVillages: [] },
  point_type: [],
});

export const GlobalVariableProvider = ({ children }) => {
  const [region, setRegion] = useState({ province: '', city: '', district: '', village: '', subvillage: '' });
  const [isDescendantOf, setIsDescendantOf] = useState(false);

  const { data: provincesList } = useRequest(`${API_URL}/provinces`, { revalidateOnFocus: false });
  const { data: citiesList } = useRequest(
    region?.province && isDescendantOf
      ? `${API_URL}/cities${queryParamBuilder({ provinceId: region.province || '' })}`
      : '',
    { revalidateOnFocus: false },
  );
  const { data: districtsList } = useRequest(
    region?.city ? `${API_URL}/districts${queryParamBuilder({ cityId: region.city || '' })}` : '',
    { revalidateOnFocus: false },
  );
  const { data: villagesList } = useRequest(
    region?.district ? `${API_URL}/villages${queryParamBuilder({ districtId: region.district || '' })}` : '',
    { revalidateOnFocus: false },
  );
  const { data: subvillagesList } = useRequest(
    region?.village ? `${API_URL}/subvillages${queryParamBuilder({ villageId: region.village || '' })}` : '',
    { revalidateOnFocus: false },
  );

  const provinces = (provincesList?.data?.province || []).map(item => {
    return { label: item?.name, value: item?.id, code: item?.code };
  });

  const cities = (citiesList?.data?.cities || []).map(item => {
    return { label: item?.name, value: item?.id, code: item?.code };
  });

  const districts = (districtsList?.data?.districts || []).map(item => {
    return { label: item?.name, value: item?.id, code: item?.code };
  });

  const villages = (villagesList?.data?.villages || []).map(item => {
    return { label: item?.name, value: item?.id, code: item?.code };
  });

  const subvillages = (subvillagesList?.data?.subVillages || []).map(item => {
    return { label: item?.name, value: item?.id, code: item?.code };
  });

  const pointType = [
    { label: 'Poin Masuk', value: 'point_in' },
    { label: 'Poin Keluar', value: 'point_out' },
  ];

  const status = [
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' },
  ];

  return (
    <GlobalVariableContext.Provider
      value={{
        pointType: pointType,
        provincesList: provinces || [],
        citiesList: cities || [],
        districtsList: districts || [],
        villagesList: villages || [],
        subvillagesList: subvillages || [],
        status: status,
        setRegion,
        setIsDescendantOf,
      }}
    >
      {children}
    </GlobalVariableContext.Provider>
  );
};

GlobalVariableProvider.propTypes = {
  children: node.isRequired,
};
